//
import { Service } from '@/services/api2'
import SlSaleCreditNoteModel from '@/models/Sale/SlSaleCreditNote'

/**
 * 
 */
export default class SlSaleCreditNoteService extends Service {

  /**
   * 
   */
  static cancel(slSaleCreditNote) {
    return slSaleCreditNote
      .cancel()
      .attach(slSaleCreditNote.toCancel())
  }

  /**
   * The api model of service
   * @returns {Object} api model
   */
  model() {
    return SlSaleCreditNoteModel
  }

  /**
   * Return a list service representation
   * @returns {Object} api model
   */
  static toList() {
    return new this()
      .model()
      .setIncludes([
        'sl_customer',
				'sl_customer_branch_offices',
      ])
  }
}